import { IconName } from "@yupma/ui-kit";
import { FieldType } from "server-model";

export const FieldTypeIconMap: Record<FieldType, IconName> = {
    [FieldType.SINGLE_LINE_TEXT]: IconName.ALPHABET,
    [FieldType.MULTI_LINE_TEXT]: IconName.ALPHABET,
    [FieldType.EMAIL]: IconName.ALPHABET,
    [FieldType.PHONE]: IconName.ALPHABET,
    [FieldType.NUMBER]: IconName.HASH,
    [FieldType.USER]: IconName.CIRCLE_USER,
    [FieldType.DATE]: IconName.CALENDAR,
    [FieldType.DATE_AND_TIME]: IconName.CALENDAR,
    [FieldType.CHECKBOX]: IconName.CHECKBOX,
    [FieldType.DROPDOWN]: IconName.SELECT_ALL_ON,
    [FieldType.MULTI_SELECT_DROPDOWN]: IconName.SELECT_ALL_ON,
    [FieldType.RICH_TEXT]: IconName.ALPHABET,
    [FieldType.FILE]: IconName.FILE,
    [FieldType.JSON]: IconName.CODE,
    [FieldType.LOCATION]: IconName.LOGO,
};

